// extracted by mini-css-extract-plugin
export default {"header":"gwvxwQs9","isScrolled":"_sQ5O2j4","areTabsStuck":"IHMQLLd2","headerInner":"EX9t6A36","landscapeActions":"mKaPMjmN","portraitActions":"oLoKLzOb"};